import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import ExternalSelect from '../ExternalSelect';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    actingBodyId: number;
    required?: boolean;
}

export default function OccurrenceTagDropdown({ value, setValue, zIndex, disabled, labelFontSize, label, actingBodyId, required }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getOccurrenceTags() {
        try {
            const actingBody = getActingBodyId();
            if (actingBody === 0) {
                setItems([]);
                return;
            }
            const response = await dispatchService.getDropDownOccurrenceTags(actingBody);
            setItems(response.map(occurrenceTag => ({
                label: occurrenceTag.name,
                value: occurrenceTag.id!,
                color: occurrenceTag.color
            })));
        } catch (err) {
            console.error(err);
        }
    }

    function getActingBodyId() {
        if (!authenticatedUser || !authenticatedUser.actingBodyUnit.actingBodyId) {
            return 0;
        }

        if (authenticatedUser.isAdmin || authenticatedUser.permissions.dispatch_manage_all_acting_bodies_occurrences) {
            return actingBodyId;
        } else {
            return authenticatedUser.actingBodyUnit.actingBodyId;
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        getOccurrenceTags();
    }, [actingBodyId, authenticatedUser]);

    return (
        <ExternalSelect
            label={label ?? translate('tags')}
            selectedLabel={translate('selectedTags')}
            items={items}
            setValue={setValue}
            required={required}
            disabled={disabled}
            labelFontSize={labelFontSize}
            value={value}
            multiple={true}
            zIndex={zIndex}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={items.filter(item => value.includes(item.value))}
        />
    );
}
